import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BaseUrlService {

  constructor(private router: Router) { }

  BaseUrl() {
     return "https://test-portal.avisoconnex.com.au"
  }
  RedirectUrl() {
    return "https://test.avisoconnex.com.au"
  }
}
